import { ResolveResource } from './utils'
import Factory from './utils/Factory'
const resource = ResolveResource(__filename)
import fetch from '@/fetch'

export default new Factory(resource, {
  publish(id, data = {}) {
    return fetch(`/api/draft/${id}/publish`, { method: 'POST', body: JSON.stringify(data) })
  },

  descendants(id) {
    return fetch(`/api/draft/${id}/descendants`, { method: 'GET' }).then(res => res.json())
  },

  reset(id, data = {}) {
    return fetch(`/api/draft/${id}/reset`, { method: 'POST', body: JSON.stringify(data) })
  },
})
